import { FormConfig } from "../../../../shared/types/legacy";

export const loginConfig: FormConfig = {
    orgaid: {
        type: 'text',
        label: '',
        autocomplete: 'off',
        hidden: false,
        disabled: false
    },
    username: {
        type: 'text',
        label: '',
        validators: ['required'],
        autocomplete: 'off'
    },
    password: {
        type: 'password',
        label: '',
        validators: ['required'],
        autocomplete: 'new-password'
    }
};

export const certConfig: FormConfig = {
  cert: {
    type: 'select',
    label: '',
    validators: ['required'],
    autocomplete: 'off',
    width: '230px'
  },
  certSelected: {
    type: 'text',
    label: '',
    disabled: true,
    hidden: true,
  },
  pin: {
    type: 'password',
    label: '',
    validators: ['required'],
    autocomplete: 'new-password',
    hidden: false
  }
};
